import type { RootState } from "store";

export const selectPageById = (state: RootState, pageId: string) => state.pages[pageId];

export const selectWorksheetIdByPage = (state: RootState, pageId: string) =>
  selectPageById(state, pageId)?.worksheet_id;
